import type { Filter } from '@/app/common/filters/core/filtersTypes.ts';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';
import { MaskIcon } from '@/app/common/icons/MaskIcon';

export const getArrowIcon = (filter: Filter): React.ReactElement | undefined => {
  if (filter.name === FILTER_NAME.SORT) {
    return <MaskIcon category="Arrows" name="icon-chevron-down" size={16} className="arrow" />;
  }

  return undefined;
};
